import { useState, useEffect, useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import {
  priceQueries,
  authorQueries,
  tagQueries,
  userQueries
} from '../../../graphql/queries';
import { UserContext } from '../../../Context';

// export default function AdminBackButton ({ destination }) {
export default function SubscriptionFormWrapper ({ children }) {
  const { user } = useContext(UserContext);
  const [authors, setAuthors] = useState(null);
  const [prices, setPrices] = useState(null);
  const [tags, setTags] = useState(null);
  const [publishers, setPublishers] = useState(null);

  const [getAuthors] = useLazyQuery(authorQueries.Authors, {
    onCompleted: (data) => {
      if (data && data.authors) {
        setAuthors(data.authors);
      }
    },
    onError: (err) => {
      console.log('getAuthors err', err);
    }
  });

  const [getPrices] = useLazyQuery(priceQueries.Prices, {
    onCompleted: (data) => {
      if (data && data.prices) {
        setPrices(data.prices);
      }
    },
    onError: (err) => {
      console.log('getPrices err', err);
    }
  });

  const [getTags] = useLazyQuery(tagQueries.Tags, {
    onCompleted: (data) => {
      if (data && data.tags) {
        setTags(data.tags);
      }
    },
    onError: (err) => {
      console.log('getTags err', err);
    }
  });

  const [getPublishers] = useLazyQuery(userQueries.Publishers, {
    onCompleted: (data) => {
      if (data && data.publishers) {
        setPublishers(data.publishers);
      }
    },
    onError: (err) => {
      console.log('getPublishers err', err);
    }
  });

  useEffect(() => {
    getAuthors();
    getPrices();
    getTags();
    getPublishers();
  }, [getAuthors, getPrices, getTags, getPublishers]);

  if (!authors || !prices || !tags || (user.type === 'Admin' && !publishers)) {
    return null;
  }

  return children({ authors, prices, tags, publishers });
}
